import cn from 'classnames';
import { useContext } from 'react';

import Text from 'components/common/Text';
import { BrandContext } from 'context/BrandContext';
import styles from 'styles/components/signUpFunnel/box/TempoBoxBanner.module.scss';

const TempoBoxBanner = () => {
  const { brand } = useContext(BrandContext);
  return (
    <div
      className={cn(
        styles[brand],
        styles.background,
        'flex-grow-0 bp1:-mb-6',
        styles.tempoBoxBanner
      )}
    >
      <div className="flex flex-col items-center px-6 py-12 text-center bp1:py-0">
        <Text brandStylesOverrides="h5 text-tempo-black-100">Over</Text>
        <Text brandStylesOverrides="text-tempo-blue-100" className="h1">
          822,000
        </Text>
        <Text brandStylesOverrides="h5 text-tempo-black-100">boxes delivered since 2023</Text>
      </div>
    </div>
  );
};

export default TempoBoxBanner;
